import Vue3Marquee from 'vue3-marquee'

export default defineNuxtPlugin(() => {
    useNuxtApp().vueApp.use(Vue3Marquee, { name: 'Vue3Marquee' })
    // useNuxtApp().vueApp.component('Vue3Marquee', Vue3Marquee)
})
